function recaptchaCallback() {
	grecaptcha.ready(function () {
		const _fields = document.querySelectorAll('.g-recaptcha');
		
		for (let i = 0, length = _fields.length; i < length; i++) {
			recaptchaExecute(_fields[i]);
		}
	});
}

function recaptchaExecute(_field) {
	grecaptcha.execute(recaptchaSiteKey, { action: _field.getAttribute('data-action') }).then((token) => {
		_field.value = token;
	});
}